module.exports = __webpack_public_path__ + "img/file-search.3c067222.svg";